<template>
  <v-container>
    <v-layout column wrap>
      <v-flex>
        <AppAreaSelector :menuSetting="menuSetting" />
      </v-flex>
      <v-flex pt-3>
        <input
          v-model="menuSetting.splitGroup"
          :disabled="isOverLimitTotalBudget"
          type="checkbox"
          class="checkbox-input"
        />
        <label class="category-text">
          {{ administrativeDistrictTypeText }}ごとに配信グループを分割する
          (配信レポートは配信グループ単位で出力されます)
        </label>
        <p class="red-text">
          ※グループ分割の機能は、お申し込み金額50万円以上からご利用いただけます。
        </p>
        <p class="additional-text">
          ※ 作成可能なグループ数の最大は10です。<br />配信対象地域の{{
            administrativeDistrictTypeText
          }}数が10を超える場合、グループ分けの詳細を備考欄へ記載してください
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AppAreaSelectorWithSplitGroupCheckbox',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    administrativeDistrictTypeText() {
      const districtType = this.menuSetting.administrativeDistrictType
      if (districtType === 'prefecture') return '都道府県'
      if (districtType === 'city') return '市区町村'
      return ''
    },
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    totalBudget() {
      let totalBudget = 0
      const notRejectedBudgets = this.form.insertionOrderBudgets.filter(
        ioBudget => ioBudget.latestRequest.requestStatus !== 'rejected',
      )
      notRejectedBudgets.map(ioBudget => {
        totalBudget += ioBudget.latestRequest.budget
      })
      return totalBudget
    },
    isOverLimitTotalBudget() {
      return this.totalBudget < 500000
    },
  },
}
</script>

<style scoped>
.red-text {
  color: red;
  margin-left: 40px;
}

.category-text {
  font-size: 20px;
  margin-left: 2em;
  display: block;
  position: relative;
  margin-top: -1.4em;
  line-height: 1.4em;
}

.additional-text {
  margin-left: 40px;
}

.checkbox-input {
  width: 20px;
  height: 20px;
}
</style>
